module.exports = __webpack_public_path__ + "img/footer-bg.c4e92e2e.png";